import React from 'react';
import { Route } from 'react-router-dom';

import AddCronPage from 'src/pages/cron/AddCronPage';
import ListCronsPage from 'src/pages/cron/ListCronsPage';
import AllowRole from 'src/components/AllowRole';

export default function CronRoutes() {
	return (
		<>
			<Route path="/cron" element={<AllowRole role={'admin'} />}>
				<Route path="listar" element={<ListCronsPage />} />
				<Route path="adicionar" element={<AddCronPage />} />
			</Route>
		</>
	);
}
